import { createContext, Dispatch, SetStateAction } from 'react'

/**
 * WebSocket操作用オブジェクトの初期値
 */
export const initialWebSocketUtilsContext = {
  start: false,
  exit: false,
  manualExit: true,
  connected: false,
  forceDisconnect: false,
}

export const WebSocketUtilsContext = createContext<WebSocketUtilsContextProps>([
  initialWebSocketUtilsContext,
  (): void => {
    // 初期値として空の関数を設定
  },
])

export type WebSocketUtilsContextProps = [
  WebSocketUtilsProps,
  Dispatch<SetStateAction<WebSocketUtilsProps>>
]

/**
 * 型定義：WebSocket操作用オブジェクト
 */
export type WebSocketUtilsProps = {
  // 接続用フラグ
  start: boolean
  // 切断用フラグ
  exit: boolean
  // 手動切断フラグ
  manualExit: boolean
  // 接続中フラグ
  connected: boolean
  // サーバからの切断命令フラグ
  forceDisconnect: boolean
  // WebSocket接続用関数
  startFunc?: () => void
  // WebSocketインスタンス
  sock?: WebSocket
}
